import { render, staticRenderFns } from "./EditTextConfiguration.vue?vue&type=template&id=528646a2"
import script from "./EditTextConfiguration.vue?vue&type=script&lang=js"
export * from "./EditTextConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports